// https://flatpickr.js.org/options/

import $ from 'jquery'
import { addDays, subYears } from 'date-fns'
import flatpickr from 'flatpickr'
import { elementExists } from '../shared'
import { selectors } from '../selectors'
import { selectorsCustomer } from '../selectors_customer'
import { VALIDATE_EVENT } from '../validation/helpers'

export const DATE_PICKER_CLASS = 'flatpickr-input'

const DATE_FORMAT = 'Y-m-d'
const DATE_FORMAT_READABLE = 'd.m.Y'
const DATE_MIN = '01.01.1900'
const DATE_MAX = '01.01.2100'
const DOB_YEARS_SHIFT = 18

const LOCALES = {
    cs: 'cs',
    en: 'en',
}

const getPromiseToPayMinDate = () => {
    if (typeof overdueValues === 'undefined') return new Date()
    const firstDateWithAmount = Object.keys(overdueValues).find((date) => parseFloat(overdueValues[date]) > 0)
    return firstDateWithAmount ?? new Date()
}

export default () => {
    const dobInput = selectors.inputs.dateOfBirth
    const p2pInput = selectorsCustomer.inputs.promiseToPayDate
    const rppInput = selectorsCustomer.inputs.reducedPlanFirstPayDate

    if (![dobInput, p2pInput, rppInput].some(elementExists)) return

    const DATE_PICKERS = [
        { input: dobInput, options: { maxDate: subYears(new Date(), DOB_YEARS_SHIFT) } },
        ...(elementExists(p2pInput) ? [{ input: p2pInput, options: { minDate: getPromiseToPayMinDate(), maxDate: addDays(new Date(), promiseMaxDaysToFuture) } }] : []),
        ...(elementExists(rppInput) ? [{ input: rppInput, options: { minDate: addDays(new Date(), 1), maxDate: addDays(new Date(), rppFirstPayMaxDaysToFuture) } }] : []),
    ]

    localize()

    DATE_PICKERS.map((elem) => {
        const { input, options } = elem
        const pickr = $(input).flatpickr({
            altInput: true,
            allowInput: true,
            dateFormat: options.format ?? DATE_FORMAT,
            altFormat: options.altFormat ?? DATE_FORMAT_READABLE,
            minDate: options.minDate ?? DATE_MIN,
            maxDate: options.maxDate ?? DATE_MAX,
            defaultDate: options.default ?? null,
            disableMobile: true,
        })
        subscribeValidation(pickr)
    })
}

const localize = () => {
    const localization = LOCALES.en
    flatpickr.localize(flatpickr.l10ns[localization])
}

const subscribeValidation = (flatpickr) => {
    $(flatpickr.input).on(VALIDATE_EVENT, (e, addedClass, removedClass) => {
        addedClass !== null && $(flatpickr.altInput).addClass(addedClass)
        removedClass !== null && $(flatpickr.altInput).removeClass(removedClass)
    })
}
